import React from 'react';
import FlowerCard from './FlowerCard';

// Flower grid component (simplified for reliability)
const FlowerGrid = ({
  flowers,
  renderKey,
  onQuantityChange,
  onClearAllFilters,
}) => {
  // Render empty state when no flowers match filters
  if (flowers.length === 0) {
    return (
      <div className="col-span-full text-center py-10">
        <p className="text-text-light">
          No flowers match your selected filters.
        </p>
        <button
          onClick={onClearAllFilters}
          className="mt-4 px-4 py-2 bg-primary text-white rounded-soft hover:bg-primary/90"
          data-testid="no-results-clear-filters-button"
        >
          Clear Filters
        </button>
      </div>
    );
  }

  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
      data-testid="flower-grid"
      data-flower-count={flowers.length}
    >
      {flowers.map((flower) => (
        <div
          key={flower.id}
          className="flower-card-container"
          data-flower-id={flower.id}
          data-flower-color={flower.color}
          data-flower-category={flower.category}
          data-testid={`flower-card-${flower.id}`}
        >
          <FlowerCard flower={flower} onQuantityChange={onQuantityChange} />
        </div>
      ))}
    </div>
  );
};

export default FlowerGrid;
